export enum WorkspaceSwitchOutcome {
  NO_OP = 'no_op',
  SWITCHED = 'switched',
  REQUIRES_PLAN_OR_RECOVERY = 'requires_plan_or_recovery',
  FAILED = 'failed',
}
